import Reveal from './Reveal'

export default function About() {
  return (
    <section id="about" aria-labelledby="about-title" className="bg-parchment text-ledger pb-24 md:pb-32">
      <div className="container mx-auto px-6">
        <div className="border-t border-rule pt-16 grid lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-5">
            <p className="site-label text-brass">04 · Who we are</p>
            <h2 id="about-title" className="site-display text-4xl md:text-5xl mt-5">
              Engineers first. Consultants second.
            </h2>
          </Reveal>

          <Reveal delay={0.06} className="lg:col-span-6 lg:col-start-7 space-y-6 text-lg leading-relaxed text-ledger/85">
            <p>
              Rozitech is a software engineering consultancy with more than 25 years of experience. We build
              enterprise software for financial services, SaaS platforms and data-heavy products. We are based in
              South Africa and have delivered production systems for clients in the US, the UK and Africa.
            </p>
            <p>
              We bring the same discipline to every engagement. We understand the domain before we touch the code,
              we design for scale from the start, and we stay accountable until the system is running well in
              production.
            </p>
            <p>
              <a
                href="https://za.linkedin.com/in/gawie-van-blerk-2a1a685"
                target="_blank"
                rel="noreferrer"
                className="site-btn-quiet site-focus-paper text-brass hover:text-ledger"
              >
                Connect on LinkedIn
              </a>
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  )
}
